let locales = {
    parameterEdit_edit: "Modifica i parametri globali",
    parameterEdit_create: "Crea parametri globali",
    parameterEdit_key: "KEY",
    parameterEdit_description: "Descrizione",
    parameterEdit_value: "Value",
    parameterEdit_type: "Tipa",
};

export default locales;